import { Column } from '../objects/column';
import { Preferences } from '../../profile/objects/preferences';
import { ListPreferenceResult, setListPreference } from '../../utils/list/utils/setListPreference';

export const MANUAL_FLIGHT_FOLDER_MODULE = 'MANUAL_FLIGHT_FOLDER';

export const DEFAULT_MANUAL_FLIGHT_FOLDER_COLUMNS: Column[] = [{
    label: 'lead-traveler',
    field_name: 'LEAD_TRAVELER',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'trip-number',
    field_name: 'TRIP_NUMBER',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'number-of-adults',
    field_name: 'NB_ADULT',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'number-of-children',
    field_name: 'NB_CHILD',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'number-of-infants',
    field_name: 'NB_INFANT',
    checked: true,
    order_by: '',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'price',
    field_name: 'PRICE',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'balance',
    field_name: 'OWED_AMOUNT',
    checked: true,
    order_by: '',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'status',
    field_name: 'STATUS',
    checked: true,
    order_by: 'status',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-date',
    field_name: 'CREATED_DATE',
    checked: false,
    order_by: 'created_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'created-by',
    field_name: 'CREATED_BY',
    checked: false,
    order_by: 'creator__username',
    fixed_width: false,
    last_updated: false,
    width: null
}, {
    label: 'modified-date',
    field_name: 'MODIFIED_DATE',
    checked: true,
    order_by: 'modified_date',
    fixed_width: true,
    last_updated: false,
    width: null
}, {
    label: 'modified-by',
    field_name: 'MODIFIED_BY',
    checked: true,
    order_by: 'last_author__username',
    fixed_width: false,
    last_updated: false,
    width: null
}];

export const setManualFlightFolderPreference = (prefs: Preferences[], cols: Column[]): ListPreferenceResult =>
    setListPreference(prefs, cols, { module: MANUAL_FLIGHT_FOLDER_MODULE, default_columns: DEFAULT_MANUAL_FLIGHT_FOLDER_COLUMNS, default_order_by: '-created_date', default_order: 'asc' });
